import React from 'react';

import { InstagramLink } from './InstagramLink';

export const InstagramLinkContainer = (
  {
    provider,
  }: {
    provider: {
      instagram?: string,
      id: number,
    }
  },
) => (
  <InstagramLink
    username={provider.instagram}
    providerId={provider.id}
  />
);
